const style = (theme) => {
  const output = {
    root: {
    },
    header: {
      extend: theme.wrapper,
      marginBottom: 30,
      display: 'flex',
    },
    counter: {
      fontSize: 20,
      color: theme.colors[2],
    },

    carousel: {
      '& .slick-dots': {
        bottom: '-50px',
        '& li': {
          width: 10,
          height: 10,
          '& button': {
            '&::before': {
              content: '""',
              width: 10,
              height: 10,
              border: `1px solid ${theme.colors[2]}`,
              background: 'transparent',
              transition: `all 0.3s ${theme.easings['power4.out']}`,
              borderRadius: '50%',
              opacity: 1,
            },
          },
          '&.slick-active': {
            '& button': {
              '&::before': {
                background: theme.colors[2],
              },
            },
          },
        },
      },
      '& .slick-track': {
        display: 'flex',
      },
      '& .slick-active': {
        '& $carouselImg': {
          '& img': {
            transform: 'scale(1)',
            opacity: 1,
          },
        },
      },
    },
    carouselItem: {
      cursor: 'pointer',
      padding: '0 45px',
    },
    carouselImg: {
      overflow: 'hidden',
      position: 'relative',
      zIndex: 1,
      '& img': {
        transition: 'opacity .6s cubic-bezier(0.8, 0, 0.2, 1), transform .6s cubic-bezier(0.2, 0, 0.2, 1)',
        opacity: 0.2,
        transform: 'scale(1.2)',
        maxWidth: 'none',
        width: 'auto',
        height: '70vh',
      },
    },

    white: {
      '& $counter': {
        color: theme.colors[1],
      },
      '& $carousel': {
        '& li': {
          '& button': {
            '&::before': {
              border: `1px solid ${theme.colors[1]}`,
            },
          },
          '&.slick-active': {
            '& button': {
              '&::before': {
                background: theme.colors[1],
              },
            },
          },
        },
      },
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    carouselImg: {
      '& img': {
        maxHeight: '40vh',
      },
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      paddingTop: 50,
    },
    header: {
      flexDirection: 'column',
    },
    counter: {
      marginLeft: 'auto',
    },
    carousel: {
      paddingBottom: 50,
      '& .slick-arrow': {
        top: 'calc(100% + 20px)',
      },
    },
  }

  return output
}

export default style
